// extracted by mini-css-extract-plugin
export default {"link":"u1MvtSI4rxKTTvsNXtA-mw=="};